<template>
  <div class="center-info">
    <div class="set-nav-title"><span class="line">个人信息</span></div>
    <div class="info-top">
      <div class="avatar-img">
        <!--<el-image :src="$common.imgPath(user.headImg)" lazy>
          <div slot="error" class="image-slot">
            <img class="tx-img" src="../../assets/images/mrtx.png" alt="头像">
          </div>
        </el-image>
        <input type="file" ref="uploadImg" style="display: none;"  @change="headImgUpload"  multiple accept="image/*">-->
        <upload-file v-model="user.headImg" :limit="1" />
        <p class="upload-txt">编辑头像</p>
      </div>
      <el-input v-model="user.nickName" placeholder="请设置用户名" style="width:230px;height:38px;"></el-input>
    </div>
    <div class="form-main">
      <div class="form-list">
        <span class="list-item lab-name">性别：</span>
        <el-radio-group v-model="user.gender">
          <el-radio :label="0">女</el-radio>
          <el-radio :label="1">男</el-radio>
        </el-radio-group>
      </div>
      <div class="form-list">
        <span class="list-item lab-name">个性签名：</span>
        <el-input v-model="user.desc" placeholder="动人以行不以言，不忘初心"  class="list-item inp-txt"></el-input>
      </div>
      <div class="form-list">
        <span class="list-item lab-name">实名认证：</span>
        <span class="list-txt" v-text="user.isReal===1?'已实名':'您还未实名认证'"></span>
        <button class="btn-main btn-small btn-name-true" v-if="user.isReal===0" @click="nameTrueVisible=true">实名认证</button>
      </div>

      <div class="form-list">
        <span class="list-item lab-name"></span>
        <div class="list-item">
          <button type="button" class="btn-base btn-save" @click="saveUserInfo()">保存</button>
          <button type="button" class="btn-base btn-del" @click="resetUser()">删除</button>
        </div>
      </div>
    </div>
    <el-dialog
            class="name-true-dialog"
            :visible.sync="nameTrueVisible"
            width="394px"
            :show-close="false"
            :before-close="nameTrueHandleClose">
      <p class="tips"><span class="cell-red">*</span>为了您的信息安全，需要您进行身份验证</p>
      <el-form :hide-required-asterisk="true" :model="nameTrueForm" :rules="nameTrueRules" ref="nameTrueForm" label-width="110px">
        <el-form-item
                label="姓名："
                prop="realName">
          <el-input type="text" v-model="nameTrueForm.realName" placeholder="请输入您的姓名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
                label="身份证号码："
                prop="cardNo">
          <el-input type="text" v-model="nameTrueForm.cardNo" placeholder="请输入您的身份证号码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <button type="button" class="btn-main btn-small" @click="submitForm('nameTrueForm')">提交</button>
          <button type="button" class="btn-base btn-small" @click="resetForm('nameTrueForm')">取消</button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import uploadFile from '../../components/uploadFile/index'
  import {uploads} from '../../api/uploadImg'
  import {userEdit,setUserReal} from '../../api/user'
  import Rules from '../../utils/rules'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,
              user:{
                  headImg:'',
                  nickName:'',
                  gender:'1',
                  desc:'',//个性签名
                  isReal:0
              },
              nameTrueVisible:false,
              nameTrueForm:{
                  cardNo:'',
                  realName:''
              },
              nameTrueRules:{
                  cardNo:Rules.idCard('请输入您的身份证号码'),
                  realName:Rules.chinese('请输入您的姓名')
              }
          }
      },
      computed:{

      },
      components:{
          uploadFile
      },
      created () {
          this.getUserInfoData();

      },
      methods:{
          changeFileHeadImg(){
              this.$refs.uploadImg.click();
          },
          headImgUpload(event){
              let imgFiles = event.target.files[0];
              uploads(imgFiles).then(res=>{
                  this.user.headImg=res.data[0];
                  console.log('res',res.data[0]);
              }).catch(err=>{
                  console.log('err',err);
              })
          },
          getUserInfoData(){
              this.$store.dispatch('getMeInfoData',this.userInfo).then(res=>{
                  console.log('res',res.data);
                  this.user={
                      id:res.data.user.id,
                      userId:res.data.user.userId,
                      desc:res.data.user.desc,
                      gender:res.data.user.gender,
                      nickName:res.data.user.nickName,
                      headImg:res.data.user.headImg,
                      isReal:res.data.user.isReal
                  };
                  console.log('user.gender',this.user.gender)
              });
          },
          saveUserInfo(){
              const form = JSON.parse(JSON.stringify(this.user));
              delete form.isReal;
              userEdit(form).then(res=>{
                  /*this.$store.dispatch('setUserInfo',res.data);*/
                  this.$message({
                      message:res.msg,
                      type:'success'
                  });
              }).catch(err=>{
                  console.log('err',err)
              })
          },
          resetUser(){
              this.user.nickName='';
              this.user.desc='';
          },
          submitForm(formName) {
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      setUserReal({
                          userId:this.userInfo.userId,
                          ...this.nameTrueForm
                      }).then((res)=>{
                          this.$message({
                              message:res.msg,
                              type:'info'
                          });
                          this.nameTrueVisible=false;
                          this.getUserInfoData();
                      })
                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          },
          resetForm(formName){
              this.nameTrueVisible=false;
              this.$refs[formName].resetFields();
          },
          nameTrueHandleClose(){

          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";
  .center-info{
    padding:30px 40px;
    background-color:#ffffff;
    .info-top{
      border-bottom:1px solid #E0E0E0;
      padding:30px;
    }
    .avatar-img{
      display: inline-block;
      vertical-align: middle;
      margin-right:20px;
      width:120px;
      height:120px;
      position: relative;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
      .tx-img{
        width:100%;
        height:100%;
      }
      .upload-txt{
        position:absolute;
        bottom:0px;
        left:0;
        width:100%;
        height:39px;
        line-height:39px;
        text-align: center;
        font-size:14px;
        color:#fff;
        background-color:rgba(0,0,0,0.5);
      }
    }
    .inp-txt{width:230px;height:38px;}
    .form-main{
      padding:0 0 75px 38px;
      .form-list{
        padding-top:30px;
        display: table;
        .list-item{
          display: table-cell;
          vertical-align: middle;}
        .lab-name{
          width:100px;
          text-align: right;padding-right:20px;}
        .list-txt{width:100px;padding-right:20px;}
        .btn-name-true{width:96px;height:30px;}
        .btn-base{width:90px;height:30px;font-size:16px;border:1px solid #BBBBBB;color:#333;
          -webkit-border-radius: 2px;
          -moz-border-radius: 2px;
          border-radius: 2px;}
        .btn-save{border:1px solid $main-color;color:$main-color;margin-right:30px;}
      }

    }
    .name-true-dialog{
      .tips{
        padding-bottom:30px;
      }
      .btn-small+.btn-small{margin-left:10px;}
    }
  }

</style>
<style lang="scss">
  @import "../../assets/css/common";
  .el-radio__input.is-checked .el-radio__inner{
    border-color: $main-color;
    background: $main-color;}
  .el-radio__input.is-checked+.el-radio__label{color:#333333;}
  .name-true-dialog .el-dialog__header{padding:0;}
  .name-true-dialog .el-dialog__body{padding:30px 40px;}
</style>
